























































































































































































































































import {Emit} from "vue-property-decorator";
import {Stored} from "vue-stored-prop-decorator";
import {Component} from '@/shared/component';
import {AbstractShowVue} from '@/components/Abstract/AbstractShowVue';
import {Devis, DevisElementsList, Tache, Temp, Token} from '@/models';

import storeDevis from '@/stores/modules/devis';
import storeToken from "@/stores/modules/token";

import CrudDevisEditDialog from '@/components/Crud/Devis/EditDialog.vue';
import CrudDeleteDialog from '@/components/Crud/DeleteDialog.vue';
import CrudTacheList from "@/components/Crud/Tache/List.vue";
import CrudTacheEditDialog from "@/components/Crud/Tache/EditDialog.vue";
import CrudTempList from "@/components/Crud/Temp/List.vue";
import CrudTempEditDialog from "@/components/Crud/Temp/EditDialog.vue";
import CrudDevisElementsListList from "@/components/Crud/DevisElementsList/List.vue";
import CrudDevisElementsListEditDialog from "@/components/Crud/DevisElementsList/EditDialog.vue";

@Component({
	components: {
		CrudDevisEditDialog,
		CrudDeleteDialog,
		CrudTacheList,
		CrudTacheEditDialog,
		CrudTempList,
		CrudTempEditDialog,
		CrudDevisElementsListList,
		CrudDevisElementsListEditDialog,
	}
})
export default class CrudDevisShow extends AbstractShowVue<Devis> {

	private imgPath: string = "";

	private editDevis: Devis = null;
	private editTache: Tache = null;
	private editTemp: Temp = null;
	private editElement: DevisElementsList = null;
	private list;
	private list2;
	private list3;

	private headers = [
		{
			text: 'Marges',
			align: 'start',
			sortable: false,
			value: 'type',
		},
		{ text: 'Prix de vente', value: 'vente' },
		{ text: 'Prix d\'achat', value: 'achat' },
		{ text: 'Marges', value: 'marges' },
	];

	private headersVAT = [
		{
			text: 'Tva',
			align: 'start',
			sortable: false,
			value: 'tva',
		},
		{ text: 'Montant', value: 'montant' },
	];

	@Stored(() => storeToken)
	private token: Token;

	public constructor() {
		super(storeDevis);
	}

	public async mounted(): Promise<void> {
		await super.mounted();
		this.list = this.$refs['list'] as CrudTacheList
		this.list2 = this.$refs['list2'] as CrudTempList
		this.list3 = this.$refs['list3'] as CrudDevisElementsListList
	}

	public async refresh(value: any): Promise<void> {
		await super.refresh(value);

		if (this.item !== null)
		{
			this.imgPath = "/img/files/proprietaire.jpg";

			if (this.$route.name === 'devis-show') {
				this.$route.meta.title = 'Détails  d\'un devis';
			}
		}

	}

	@Emit()
	private onCreate(): void {
		let element = new DevisElementsList()
		element.devis = this.item
		this.editElement = element
	}

	@Emit()
	private onCreateTemp(): void {
		let temp = new Temp()
		temp.client = this.item.client
		this.editTemp = temp;
	}

	private get hrefPdf(): string {
		return `${process.env.VUE_APP_BACK_BASE_URL}/pdf/devis/${this.item.id}?token=${this.token.id}`;
	}

	private async putChangeState(devis: Devis, refused: boolean = false): Promise<void> {
		await storeDevis.dispatch('putChangeState', { devis: devis, refused: refused } );
		await storeDevis.dispatch('get', this.value.id);
		this.list3 = this.$refs['list3'] as CrudDevisElementsListList
		await this.list3.refresh()
	}
}
